<template>
  <div class="news-detail-page">
    <PageHeader
        title="新闻详情"
        :subtitle="currentNews?.title || '新闻详情'"
        :breadcrumbItems="[
        { text: '首页', path: '/' },
        { text: '新闻详情', path: '/news' }
      ]"
        :currentText="currentNews?.title || '加载中...'"
    />

    <div class="page-container" v-loading="loading">
      <!-- 新闻详情 -->
      <div v-if="currentNews" class="news-detail">
        <div class="news-header">
          <h1 class="news-title">{{ currentNews.title }}</h1>
          <div class="news-meta">
            <span class="category">{{ getCategoryName(currentNews.category) }}</span>
            <span class="date">{{ formatDate(currentNews.editTime) }}</span>
            <span class="views">阅读：{{ currentNews.viewCount || 0 }}</span>
          </div>
        </div>

<!--        <div class="news-cover" v-if="currentNews.cover">-->
<!--          <img :src="currentNews.cover" :alt="currentNews.title" />-->
<!--        </div>-->

        <div class="news-content" v-html="currentNews.content"></div>
      </div>

      <!-- 错误提示 -->
      <el-alert v-if="error" type="error" :title="error" :closable="false" show-icon></el-alert>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import {getHotNews, getNewsCategories, getNewsDetail} from '@/api/news';
import { formatDate } from '@/utils/helper';
import PageHeader from '@/components/PageHeader.vue';


export default {
  name: 'NewsDetailView',
  components: {
    PageHeader,
  },
  setup() {
    const route = useRoute();
    const newsId = ref(route.params.id);
    const loading = ref(false);
    const error = ref('');
    const categories = ref([]);
    const relatedNews = ref([]); // 实际上只会装一条当前新闻

    const currentNews = computed(() => relatedNews.value[0] || null);

    const fetchCategories = async () => {
      try {
        const res = await getNewsCategories();
        if (res.data?.ActionType === 'ok') {
          categories.value = res.data.data;
        }
      } catch (err) {
        console.error('获取新闻分类失败:', err);
      }
    };

    const fetchCurrentNews = async () => {
      loading.value = true;
      error.value = '';
      try {
        const res = await getNewsDetail(newsId.value);
        if (res.data?.ActionType === 'ok') {
          relatedNews.value = res.data.data.filter(item => item._id === newsId.value);
          if (relatedNews.value.length === 0) {
            error.value = '未找到该新闻';
          }
        } else {
          error.value = '获取新闻失败';
        }
      } catch (err) {
        error.value = '获取新闻失败';
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    const getCategoryName = (categoryId) => {
      if (!categoryId) return '未分类';
      const category = categories.value.find(c => c.id === categoryId);
      return category ? category.name : '未分类';
    };

    const loadData = () => {
      fetchCategories();
      fetchCurrentNews();
    };

    watch(() => route.params.id, (newId) => {
      if (newId && newId !== newsId.value) {
        newsId.value = newId;
        loadData();
      }
    });

    onMounted(loadData);

    return {
      currentNews,
      error,
      loading,
      formatDate,
      getCategoryName,
    };
  }
};
</script>

<style lang="scss" scoped>
.news-detail-page {
  padding-top: 100px; /* 根据导航栏高度调整 */


  .news-detail {
    margin-bottom: 50px;

    .news-header {
      margin-bottom: 30px;
      text-align: center;

      .news-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 15px;
      }

      .news-meta {
        display: flex;
        justify-content: center;
        color: #999;
        font-size: 14px;
        gap: 20px;

        .category {
          background-color: #f0f9ff;
          color: #409eff;
          padding: 2px 8px;
          border-radius: 2px;
        }
      }
    }

    .news-cover {
      margin-bottom: 30px;
      text-align: center;

      img {
        max-width: 100%;
        border-radius: 8px;
      }
    }

    .news-content {
      font-size: 16px;
      line-height: 1.8;
      color: #333;

      ::v-deep(img) {
        max-width: 100%;
        height: auto;
      }

      ::v-deep(p) {
        margin-bottom: 1em;
      }

      ::v-deep(h2) {
        margin: 1.5em 0 0.8em;
        font-size: 22px;
      }

      ::v-deep(h3) {
        margin: 1.2em 0 0.6em;
        font-size: 20px;
      }
    }
  }

  .related-news {
    margin-top: 50px;

    .section-title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
      position: relative;
      padding-left: 15px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 8px;
        height: 20px;
        width: 4px;
        background-color: #409eff;
      }
    }

    .related-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;

      @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>
